import React from 'react';
import moment from 'moment';
import i18n from './helpers/i18n';
export const UNKNOWN_ERROR_MESSAGE = 'UNKNOWN_ERROR_MESSAGE';

export const EnvConfig = {
  googleMapKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
};
export const AppName = 'Prisme';
export const authBackgroundImg = require('./assets/backgrounds/authbg.jpg');
export const appLogoImage = require('./assets/logos/applogo.png');

export const AppLogo = (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => {
  return <img src={appLogoImage} alt="app-logo" {...props} />;
};

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

// Format des dates affichées (étape 5, 2026-11-02) : celui de la compagnie (Paramètres › Général), reçu à la connexion et
// gardé sur ce navigateur ; « JJ/MM/AAAA » par défaut. Réglage enregistré au format .NET (dd/MM/yyyy) ou moment.
const COMPANY_DATE_FORMAT_KEY = 'company-date-format';
export const SupportedDateFormat = ['DD/MM/YYYY', 'YYYY/MM/DD'];
export const toDisplayDateFormat = (value?: string | null) =>
  SupportedDateFormat.find(f => f === (value || '').trim().toUpperCase()) || SupportedDateFormat[0];
const storedDateFormat = () => {
  try {
    return localStorage.getItem(COMPANY_DATE_FORMAT_KEY);
  } catch {
    return null;
  }
};

export let DEFAULT_DISPLAY_DATE_FORMAT = toDisplayDateFormat(storedDateFormat());
export let DEFAULT_DISPLAY_DATETIME_FORMAT = `${DEFAULT_DISPLAY_DATE_FORMAT} HH:mm`;
export let DEFAULT_DISPLAY_DATE_TIME_FORMAT = `${DEFAULT_DISPLAY_DATE_FORMAT} HH:mm`;
export const DEFAULT_DISPLAY_TIME_FORMAT = 'HH:mm';

/** Format enregistré pour le serveur, qui l'utilise avec .NET (« dd/MM/yyyy ») : jour et année en minuscules. */
export const toServerDateFormat = (value?: string | null) => toDisplayDateFormat(value).replace('DD', 'dd').replace('YYYY', 'yyyy');

/** Applique le format de la compagnie (connexion, enregistrement des paramètres) ; les écrans le lisent à l'affichage. */
export const applyCompanyDateFormat = (value?: string | null) => {
  DEFAULT_DISPLAY_DATE_FORMAT = toDisplayDateFormat(value);
  DEFAULT_DISPLAY_DATETIME_FORMAT = `${DEFAULT_DISPLAY_DATE_FORMAT} HH:mm`;
  DEFAULT_DISPLAY_DATE_TIME_FORMAT = DEFAULT_DISPLAY_DATETIME_FORMAT;
  try {
    if (value) localStorage.setItem(COMPANY_DATE_FORMAT_KEY, DEFAULT_DISPLAY_DATE_FORMAT);
  } catch {
    // Stockage indisponible : format appliqué pour cette session seulement.
  }
};

export const formatDate = dateStr => {
  return dateStr ? moment(dateStr).format(DEFAULT_DATE_FORMAT) : '';
};
export const formatApiDateTime = (dateStr): any => {
  return dateStr ? moment(dateStr).format(DEFAULT_DATE_TIME_FORMAT) : '';
};
export const formatApiDate = (dateStr): any => {
  return dateStr ? moment(dateStr).format(DEFAULT_DATE_FORMAT) : '';
};
export const formatDisplayDate = dateStr => {
  return dateStr ? moment(dateStr).format(DEFAULT_DISPLAY_DATE_FORMAT) : '';
};
export const formatDisplayDateTime = dateStr => {
  return dateStr ? moment(dateStr).format(DEFAULT_DISPLAY_DATE_TIME_FORMAT) : '';
};
export const formatDisplayFullDate = dateStr => {
  return dateStr ? moment(dateStr).format(DEFAULT_DISPLAY_DATETIME_FORMAT) : '';
};

export const PasswordRegex = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';

export const HIDE_MESSAGE_401_PARAMS = '___No_Display_Error_Message';
export const PAGE_SIZE_OPTION = ['10', '20', '30', '50', '100'];
export const DEFAULT_PAGE_SIZE = 20;
export const VALIDATE_REQUIRED = i18n.t('VALIDATE_REQUIRED');
export const ROW_GUTTER = 6;
export const MenuIconColor = {
  AdminPortal: '#1c6f97',
};

export const ModalWidth = {
  small: 500,
  medium: 700,
  large: 1000,
  extraLarge: 1200,
};

export const SupportedTimeFormat = ['HH:mm'];
export const AccountNumberRegex = '^[0-9]*$';

export const AutocompletionLimit = 200;

export const Timezones = [
  '(UTC-12:00) International Date Line West',
  '(UTC-11:00) Coordinated Universal Time-11',
  '(UTC-10:00) Aleutian Islands',
  '(UTC-10:00) Hawaii',
  '(UTC-09:30) Marquesas Islands',
  '(UTC-09:00) Alaska',
  '(UTC-09:00) Coordinated Universal Time-09',
  '(UTC-08:00) Baja California',
  '(UTC-08:00) Coordinated Universal Time-08',
  '(UTC-08:00) Pacific Time (US &amp; Canada)',
  '(UTC-07:00) Arizona',
  '(UTC-07:00) La Paz, Mazatlan',
  '(UTC-07:00) Mountain Time (US &amp; Canada)',
  '(UTC-07:00) Yukon',
  '(UTC-06:00) Central America',
  '(UTC-06:00) Central Time (US &amp; Canada)',
  '(UTC-06:00) Easter Island',
  '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
  '(UTC-06:00) Saskatchewan',
  '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
  '(UTC-05:00) Chetumal',
  '(UTC-05:00) Eastern Time (US &amp; Canada)',
  '(UTC-05:00) Haiti',
  '(UTC-05:00) Havana',
  '(UTC-05:00) Indiana (East)',
  '(UTC-05:00) Turks and Caicos',
  '(UTC-04:00) Asuncion',
  '(UTC-04:00) Atlantic Time (Canada)',
  '(UTC-04:00) Caracas',
  '(UTC-04:00) Cuiaba',
  '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
  '(UTC-04:00) Santiago',
  '(UTC-03:30) Newfoundland',
  '(UTC-03:00) Araguaina',
  '(UTC-03:00) Brasilia',
  '(UTC-03:00) Cayenne, Fortaleza',
  '(UTC-03:00) City of Buenos Aires',
  '(UTC-03:00) Montevideo',
  '(UTC-03:00) Punta Arenas',
  '(UTC-03:00) Saint Pierre and Miquelon',
  '(UTC-03:00) Salvador',
  '(UTC-02:00) Coordinated Universal Time-02',
  '(UTC-02:00) Greenland',
  '(UTC-02:00) Mid-Atlantic - Old',
  '(UTC-01:00) Azores',
  '(UTC-01:00) Cabo Verde Is.',
  '(UTC+00:00) Coordinated Universal Time',
  '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
  '(UTC+00:00) Monrovia, Reykjavik',
  '(UTC+00:00) Sao Tome',
  '(UTC+01:00) Casablanca',
  '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
  '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
  '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
  '(UTC+01:00) West Central Africa',
  '(UTC+02:00) Athens, Bucharest',
  '(UTC+02:00) Beirut',
  '(UTC+02:00) Cairo',
  '(UTC+02:00) Chisinau',
  '(UTC+02:00) Gaza, Hebron',
  '(UTC+02:00) Harare, Pretoria',
  '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  '(UTC+02:00) Jerusalem',
  '(UTC+02:00) Juba',
  '(UTC+02:00) Kaliningrad',
  '(UTC+02:00) Khartoum',
  '(UTC+02:00) Tripoli',
  '(UTC+02:00) Windhoek',
  '(UTC+03:00) Amman',
  '(UTC+03:00) Baghdad',
  '(UTC+03:00) Damascus',
  '(UTC+03:00) Istanbul',
  '(UTC+03:00) Kuwait, Riyadh',
  '(UTC+03:00) Minsk',
  '(UTC+03:00) Moscow, St. Petersburg',
  '(UTC+03:00) Nairobi',
  '(UTC+03:00) Volgograd',
  '(UTC+03:30) Tehran',
  '(UTC+04:00) Abu Dhabi, Muscat',
  '(UTC+04:00) Astrakhan, Ulyanovsk',
  '(UTC+04:00) Baku',
  '(UTC+04:00) Izhevsk, Samara',
  '(UTC+04:00) Port Louis',
  '(UTC+04:00) Saratov',
  '(UTC+04:00) Tbilisi',
  '(UTC+04:00) Yerevan',
  '(UTC+04:30) Kabul',
  '(UTC+05:00) Ashgabat, Tashkent',
  '(UTC+05:00) Ekaterinburg',
  '(UTC+05:00) Islamabad, Karachi',
  '(UTC+05:00) Qyzylorda',
  '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
  '(UTC+05:30) Sri Jayawardenepura',
  '(UTC+05:45) Kathmandu',
  '(UTC+06:00) Astana',
  '(UTC+06:00) Dhaka',
  '(UTC+06:00) Omsk',
  '(UTC+06:30) Yangon (Rangoon)',
  '(UTC+07:00) Bangkok, Hanoi, Jakarta',
  '(UTC+07:00) Barnaul, Gorno-Altaysk',
  '(UTC+07:00) Hovd',
  '(UTC+07:00) Krasnoyarsk',
  '(UTC+07:00) Novosibirsk',
  '(UTC+07:00) Tomsk',
  '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
  '(UTC+08:00) Irkutsk',
  '(UTC+08:00) Kuala Lumpur, Singapore',
  '(UTC+08:00) Perth',
  '(UTC+08:00) Taipei',
  '(UTC+08:00) Ulaanbaatar',
  '(UTC+08:45) Eucla',
  '(UTC+09:00) Chita',
  '(UTC+09:00) Osaka, Sapporo, Tokyo',
  '(UTC+09:00) Pyongyang',
  '(UTC+09:00) Seoul',
  '(UTC+09:00) Yakutsk',
  '(UTC+09:30) Adelaide',
  '(UTC+09:30) Darwin',
  '(UTC+10:00) Brisbane',
  '(UTC+10:00) Canberra, Melbourne, Sydney',
  '(UTC+10:00) Guam, Port Moresby',
  '(UTC+10:00) Hobart',
  '(UTC+10:00) Vladivostok',
  '(UTC+10:30) Lord Howe Island',
  '(UTC+11:00) Bougainville Island',
  '(UTC+11:00) Chokurdakh',
  '(UTC+11:00) Magadan',
  '(UTC+11:00) Norfolk Island',
  '(UTC+11:00) Sakhalin',
  '(UTC+11:00) Solomon Is., New Caledonia',
  '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
  '(UTC+12:00) Auckland, Wellington',
  '(UTC+12:00) Coordinated Universal Time+12',
  '(UTC+12:00) Fiji',
  '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
  '(UTC+12:45) Chatham Islands',
  '(UTC+13:00) Coordinated Universal Time+13',
  "(UTC+13:00) Nuku'alofa",
  '(UTC+13:00) Samoa',
  '(UTC+14:00) Kiritimati Island',
];

export const TimeZoneOptions = Timezones.map(t => ({
  value: parseFloat(t.substring(4, 10).replace(':', '.')),
  label: t,
  key: t,
}));


export const formatDuration = (duration: any) => {
  if (duration) {
    const hrs = Math.floor(duration / 60);
    const minutes = duration % 60;
    let str = '';
    if (hrs) {
      if (hrs > 1) {
        str += `${hrs} hrs`;
      } else {
        str += `${hrs} hr`;
      }
    }
    if (minutes) {
      if (minutes > 1) {
        str += ` ${minutes} mins`;
      } else {
        str += ` ${minutes} min`;
      }
    }

    return str;
  }
  return 'unknown';
};

export const dateTimeDisplayFormat = {
  timeOnly: (v: any) => (v ? moment(v).format(DEFAULT_DISPLAY_TIME_FORMAT) : ''),
  dateOnly: (v: any) => (v ? moment(v).format(DEFAULT_DISPLAY_DATE_FORMAT) : ''),
  dateTime: (v: any) => (v ? moment(v).format(DEFAULT_DISPLAY_DATE_TIME_FORMAT) : ''),

  originDateOnly: (v: any, defaultValue: string = '') => {
    try {
      return v ? moment(`${v.slice(0, 10)}T23:59`).format(DEFAULT_DISPLAY_DATE_FORMAT) : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  },
  originDateAndMonthOnly: (v: any, defaultValue: string = '') => {
    try {
      return v ? moment(`${v.slice(0, 10)}T23:59`).format('DD/MM') : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  },
  originTimeOnly: (v: any, defaultValue: string = '') => {
    try {
      return v ? v.slice(11, 16) : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  },
  originDateTime: (v: any, defaultValue: string = '') => {
    try {
      return v ? `${moment(`${v.slice(0, 10)}T23:59`).format(DEFAULT_DISPLAY_DATE_FORMAT)} ${v.slice(11, 16)}` : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  },
  originDateTimeNoYear: (v: any, defaultValue: string = '') => {
    try {
      return v ? `${moment(`${v.slice(0, 10)}T23:59`).format('DD/MM')} ${v.slice(11, 16)}` : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  },
};

export const toNoTimeZoneDate = (value: any) => {
  if (value && typeof value === 'string') {
    let v: any = value;
    let dataString: string = v.slice(0, 10);
    let timeString: string = v.slice(11, 16);
    let newValue = moment(`${dataString}T23:59:59`).endOf('D');
    let h: any = parseInt(timeString?.split(':')?.at(0) || '');
    let m: any = parseInt(timeString?.split(':')?.at(1) || '');
    newValue = newValue.set('h', h || 0);
    newValue = newValue.set('m', m || 0);

    return newValue;
  }
  return value;
};
